import '../../styles/components/localization-form.scss';

class LocalizationForm extends HTMLElement {
  constructor() {
    super();

    this.form = this.querySelector('form');
    this.select = this.form.querySelector('select');

    this.select?.addEventListener('change', this.localizationChange.bind(this));
  }

  localizationChange() {
    this.form.submit();
  }
}

try {
  customElements.define('localization-form', LocalizationForm);
}
catch(e) {}
